<template>
  <el-form>
    <el-form-item>
      <el-text size="large" type="warning">{{ props.income.model }}</el-text>
    </el-form-item>
    <el-form-item label="Сумма" label-position="top">
      <el-input v-model.number="amount" type="number" />
    </el-form-item>
    <el-form-item label="Коммент" label-position="top">
      <el-input v-model.trim="comment" type="textarea" />
    </el-form-item>
    <el-form-item label="Скриншоты">
      <el-upload multiple :auto-upload="false" accept="image/*" v-model:file-list="screenshots">
        <el-button>
          <el-space
            >Загрузить все <el-icon><upload-filled /></el-icon> </el-space
        ></el-button>
      </el-upload>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="addDelayed">Добавить</el-button>
    </el-form-item>
  </el-form>
</template>
<script setup lang="ts">
import type { IncomeToCreate } from '@/api/resources/incomes.ts/model'
import type Income from '@/api/resources/incomes.ts/model'
import { UploadFilled } from '@element-plus/icons-vue'
import type { UploadFile } from 'element-plus'
import { ref } from 'vue'

const props = defineProps<{ income: Income }>()
const amount = ref<number | undefined>()
const comment = ref<string>('')
const screenshots = ref<UploadFile[]>()

const emit = defineEmits<{
  (e: 'change', shiftId: number, income: IncomeToCreate, screenshots: UploadFile[]): void
}>()

const addDelayed = async () => {
  emit(
    'change',
    props.income.shift_id,
    {
      amount: amount.value ?? 0,
      model: props.income.model,
      comment: comment.value,
      is_delayed: true,
      shift_id: props.income.shift_id,
      success_poor_detects: 0,
      failed_poor_detects: 0,
      in_progress: 0,
      unread: 0,
    },
    screenshots.value ?? [],
  )
}
</script>
<style scoped lang></style>
